import React from 'react';
import ContactSect from '../contact/contact';
import FormSect from '../form';
function contact() {
  return (
    <div>
        <div className="uk-section bg-primary">
            <div className="uk-container uk-text-center">
                <ContactSect/>
            </div>
        </div>
        <div className="uk-section">
          <div className="uk-container">
            <FormSect/>
          </div>
        </div>
    </div>
  )
}

export default contact